export const CALCULATION_BEGINS = "Huella_Inicio";
export const CALCULATION_ENDS = "Huella_fin";

export const REGISTER = "Huella_Registro";
